module.exports = __webpack_public_path__ + "assets/img/thumb-SpinTel-Social-Static-Ad.f125137a.jpg";